import Entity from '../entity'
import OrderItem from './OrderItem';

export default class Order extends Entity<number>{
    addressId: number  = null;
    wxUserId: number  = null;
    userId: string  = null;
    userName: string  = null;
    paymentMethod: number  = null;
    status: number  = null;
    description: string  = null;
    tenantId: number  = null;
    addressInfo: string  = null;
    orderNo: string  = null;
    shipmentStatus: number  = null;
    couponNo: string  = null;
    paidAmount: string  = null;
    paidTime: Date  = null;
    vendorNo: string  = null;
    creationTime: string;
    remark: string  = null;
    orderItems: Array<OrderItem>;
    userNo: string;
    payableAmount: number; // 应付金额
    cooperationMode: string;
}